<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="$jsTool.getOrderApprovalStatusType(head.orderApprovalStatusEnum)"
        >{{ head.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="2">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="供应商" span="3">
      {{ head.supplier.name }}
    </el-descriptions-item>
    <el-descriptions-item label="所选商品" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="500px"
        :span-method="objectSpanMethod"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="商品图片"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityImage
              :commodity="scope.row.commoditySnapshot"
              v-if="scope.row.saleSuitId"
            ></CommodityImage>
            <CommodityImage
              :commodity="scope.row.commoditySnapshot"
              :commoditySpec="scope.row.commoditySpecSnapshot"
              v-else
            ></CommodityImage>
          </template>
        </el-table-column>
        <el-table-column
          prop="commoditySnapshot.name"
          label="套装 / 商品信息"
          min-width="200"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="line-height: 1.4em">
              <span style="font-size: 1.1em">{{
                scope.row.commoditySnapshot.name
              }}</span
              ><br />
              {{ "分类：" + scope.row.commoditySnapshot.commodityCategory.name
              }}<br />
              {{ "颜色：" + scope.row.commoditySnapshot.color }}<br />
              <div class="fm-margin-top-5" v-if="scope.row.saleSuitId">
                <span style="font-size: 1.1em">{{
                  "套装名称：" + scope.row.saleSuitName
                }}</span
                ><br />
                <div class="fm-flex">
                  套装采购价：
                  <fm-amount
                    :amount="scope.row.saleSuitRetailPrice"
                  ></fm-amount>
                </div>
                {{ "套装采购数量：" + scope.row.saleSuitQuantity }}<br />
                <div class="fm-flex">
                  套装总采购价：
                  <fm-amount :amount="scope.row.saleSuitSumAmount"></fm-amount>
                </div>
                <div class="fm-flex">
                  套装折扣金额：
                  <fm-amount
                    :amount="scope.row.saleSuitDisCountAmount"
                  ></fm-amount>
                </div>
                <div class="fm-flex">
                  套装成交价：
                  <fm-amount :amount="scope.row.saleSuitAmount"></fm-amount>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="commoditySpecSnapshot.specName"
          label="商品规格"
          min-width="100"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="retailPrice"
          label="商品采购价"
          width="120"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.retailPrice"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="数量"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.itemQuantity + scope.row.commoditySnapshot.unit }}
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="金额"
          width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              总采购价：
              <FmAmount
                :amount="scope.row.commodityRetailTotalAmount"
              ></FmAmount>
            </div>
            <div class="fm-flex">
              折扣金额：<FmAmount :amount="scope.row.disCountAmount"></FmAmount>
            </div>
            <div class="fm-flex">
              成交价：<FmAmount :amount="scope.row.itemAmount"></FmAmount>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="入库进度"
          width="150"
          align="left"
          header-align="center"
          v-if="head.orderApprovalStatusEnum.Name == 'Approval'"
        >
          <template slot-scope="scope">
            {{ "待入库 " + scope.row.toBeInputQuantity }}<br />
            {{
              "入库中 " +
              scope.row.inputingQuantity +
              " , 已入库 " +
              scope.row.completedInputQuantity
            }}<br />
            {{
              "退货中 " +
              scope.row.returningQuantity +
              " , 已退货 " +
              scope.row.completedReturnQuantity
            }}<br />
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item label="单据金额" span="3">
      <div class="fm-flex">
        <FmAmount :amount="head.orderAmount"></FmAmount>
        （总采购价：<FmAmount
          :amount="head.commodityRetailTotalAmount"
        ></FmAmount
        >，优惠金额：<FmAmount :amount="head.disCountAmount"></FmAmount>）
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="付款进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          付款进度：
          <span
            v-fmtype="$jsTool.getFundPayProgressType(head.fundPayProgressEnum)"
          >
            {{ head.fundPayProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">
          待付：<FmAmount :amount="head.toBePayAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          付款中：<FmAmount :amount="head.payingAmount"></FmAmount
          >，已付款：<FmAmount :amount="head.completedPayAmount"></FmAmount
          >，付款优惠：<FmAmount :amount="head.payDisCountAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          退款中：<FmAmount :amount="head.returningAmount"></FmAmount
          >，已退款：<FmAmount :amount="head.completedReturnAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          全部付款时间：<span v-fmtype="head.fullPayTime ? '' : 'warning'">{{
            head.fullPayTime || "暂无"
          }}</span>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="入库进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          入库进度：
          <span
            v-fmtype="
              $jsTool.getCommodityInputProgressType(
                head.commodityInputProgressEnum
              )
            "
          >
            {{ head.commodityInputProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">待入库：{{ head.toBeInputQuantity }}</div>
        <div class="fm-flex">
          入库中：{{ head.inputingQuantity }}，已入库：{{
            head.completedInputQuantity
          }}
        </div>
        <div class="fm-flex">
          退货中：{{ head.returningQuantity }}，已退货：{{
            head.completedReturnQuantity
          }}
        </div>
        <div class="fm-flex">
          全部入库时间：<span v-fmtype="head.fullInputTime ? '' : 'warning'">{{
            head.fullInputTime || "暂无"
          }}</span>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="业务员" span="3">
      {{ head.saleUserList.map((d) => d.user.name).join("、") }}
    </el-descriptions-item>
    <el-descriptions-item label="拓展字段" span="3">
      <div v-if="head.extFieldValueList && head.extFieldValueList.length > 0">
        <div v-for="(item, index) in head.extFieldValueList" :key="index">
          {{
            item.label + "：" + (item.value == null ? "-" : item.value) + ";"
          }}
        </div>
      </div>
      <div v-fmtype="'warning'" v-else>—</div>
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="流程信息" span="3">
      <OrderStep :orderInfo="head" :displayTime="displayTime"></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebPurchaseOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = newVal;
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.head
        ? this.showOrderInfo.head
        : {};
    },
    itemList() {
      if (this.showOrderInfo && this.showOrderInfo.itemList) {
        let arr = this.showOrderInfo.itemList;
        // 分离有saleSuitId和无saleSuitId的项
        let withSuit = arr.filter((item) => item.saleSuitId);
        let withoutSuit = arr.filter((item) => !item.saleSuitId);
        // 对有saleSuitId的项进行排序
        withSuit.sort((a, b) => {
          if (a.saleSuitId < b.saleSuitId) return -1;
          if (a.saleSuitId > b.saleSuitId) return 1;
          return a.itemNo - b.itemNo; // 同一saleSuitId按itemNo排序
        });

        // 对无saleSuitId的项进行排序
        withoutSuit.sort((a, b) => a.itemNo - b.itemNo);

        // 合并两个数组
        let res = [...withSuit, ...withoutSuit];
        res.forEach((item, index) => {
          item.itemNo = index + 1; // 索引从 0 开始，所以 itemNo 从 1 开始
        });
        return res;
      }
      return [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:PurchaseOrder:NeedApproval",
        "Order:PurchaseOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.purchaseOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if ((columnIndex == 1 || columnIndex == 2) && row.saleSuitId) {
        let list = this.itemList
          .filter((d) => d.saleSuitId && d.saleSuitId == row.saleSuitId)
          .sort((a, b) => {
            return a.itemNo - b.itemNo;
          });
        if (list[0].itemNo == row.itemNo) {
          return {
            rowspan: list.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/PurchaseOrderInfo.vue